import{fileuploader as e}from"./fileUploader.mjs";const s=Object.assign(Object.assign({},e),{filelist:{flexDirection:"column",gap:"{space.small}"}});export{s as storagemanager};
